import React, { useState, useEffect } from "react";
import ConnectAPI from "../../../services/api";
import { authenticationService } from "../../../services/context/AuthService";
import Swal from "sweetalert2";
import { Button, Table, ConfirmationModal, Modal, FilePicker, InlineNotification } from "@veneer/core";
import ApprovalConfirmationModal from "./InformationModal";
import RejectConfirmationModal from "./RejectConfirmationModal"
import SpecialConditionDetail from "./SpecialConditionDetail";
import SpecialConditionDetailLvlChannel from "./SpecialConditionDetailLvlChannel";
import $ from 'jquery';
import { useTranslation } from "react-i18next";

const connectApi = new ConnectAPI();

function SpecialConditionApproval(props) {
    const [specialConditionsList, setSpecialConditionList] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [userEmail] = useState(authenticationService.currentUserValue.email);
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();

    let getSCdataCallback;
    var fetchData;
    let email = authenticationService.currentUserValue.email;
    useEffect(() => {//validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
            if (ur==window.location.pathname){
                validate=true;
            }
        });
        if (validate==false){
            const { history } = props;
            history.push({
            pathname: '/' 
            });
        }//end validate
        fetchData();
        checkSizeToUpload();
    }, []);

    getSCdataCallback = (status, data) => {
        data.forEach(obj => {
            obj.rowConfig = { 'selected': false };
        });
        if(JSON.parse(localStorage.getItem("currentUser")).idRole == 9){
            var filter = data.filter((x) => x.idCustomer == JSON.parse(localStorage.getItem("currentUser")).idCustomer );
            setTableData(filter);
        } else
            setTableData(data);
        
        let numero = Math.ceil(data.length / pageSize) || 1;
        if(numero < currentPage)
            setCurrentPage(numero);

        setIsLoading(false);
    }
    fetchData = async () => {
        connectApi.getWithParams("api/Channels/specialConditionsUnapproved", email, getSCdataCallback)
        .catch ((error) => {
            setIsLoading(false);
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
            );
        });
        setIsLoading(true);
    }
    const [specialConditionsIds, setSpecialConditionsIds] = useState([]);

    //Handles special condition selection to approve or reject
    const handleRowSelect = (event, rowId) => {
        const { checked } = event.target;
        const newTableData = [...tableData];
        const rowIndex = newTableData.findIndex((row) => row.idSpecialCondition === rowId);
        newTableData[rowIndex].rowConfig.selected = checked;
        //adds SC ids to the approval/rejection list
        if (specialConditionsListCopy && specialConditionsListCopy.length > 0) {
            setSpecialConditionList(specialConditionsListCopy);
        }

        let specialConditionArray = []
        if (checked) {
            specialConditionArray = specialConditionsList.concat([rowId]);
            setSpecialConditionList(specialConditionArray)
        } else {
            specialConditionArray = specialConditionsList;
            let index = specialConditionsList.indexOf(rowId);
            specialConditionArray.splice(index, 1);
            setSpecialConditionList(specialConditionArray)
        }
       
        if (specialConditionsList.length > 0) {
            let ids = ""
            setSpecialConditionsIds("");
            specialConditionsList.forEach(element => {
                ids += " "+element;
            })
            setSpecialConditionsIds(ids)
        }
        setTableData(newTableData);
    };

    const handleSelectAllItems = (event) => setTableData(selectAllPageItems(tableData, pagedData, event.target.checked));
    function selectAllPageItems(tableData, pagedData, checked) {
        const tableDataInter = tableData.map((row) => {
            const newRow = row;
            const index = pagedData.findIndex((p) => p.idSpecialCondition === newRow.idSpecialCondition);
            if (index > -1) newRow.rowConfig.selected = checked;
            return newRow;
        });

        const rowIds = pagedData.map(row => row.idSpecialCondition.toString());
        let updatedSpecialConditions = [...specialConditionsList];
        if (checked) {
            rowIds.forEach((id) => {
                if (!updatedSpecialConditions.includes(id)) updatedSpecialConditions.push(id);
            });
        } else updatedSpecialConditions = updatedSpecialConditions.filter(id => !rowIds.includes(id));

        setSpecialConditionList(updatedSpecialConditions);
        if (updatedSpecialConditions.length > 0) {
            const idArray = updatedSpecialConditions.map(id => id.toString());
            setSpecialConditionsIds(idArray);
        } else setSpecialConditionsIds([]);
        
        return tableDataInter;
    }
    function selectionState(dataArray) {
        const total = dataArray.length;
        const selected = dataArray.filter((row) => row.rowConfig.selected).length;
        switch (selected) {
            case 0:
                return 'none';
            case total:
                return 'all';
            default:
                return 'indeterminated';
        }
    }

    const ApprovedSelectedEC = () => { if(specialConditionsList.length > 0) setModalState({ show: true }); }
    const RejectEC = () => { if(specialConditionsList.length > 0) setRejectModal({ show: true }); }
    const [modalState, setModalState] = useState(false);

    const approvingSCFlow = () => {
        setShowSCDetail(false);
        setIsLoading(true);
        
        let payload = {
            specialConditionsList: specialConditionsList,
            email: userEmail,
            status: 'Approved'
        }
        setFlowStatus('Approved');
        connectApi.post('api/Channels/ChangeSpecialConditionStatusFlow', payload, approverSPCallback);
    }
    const approvingSCFlow_by1 = () => {
        setShowSCDetail(false);
        setIsLoading(true);
        
        let payload = {
            specialConditionsList: specialConditionsList,
            email: userEmail,
            status: 'Approved'
        }
        let data={
            payload:payload,
            SpecialCondition:specialConditionDetail

        }
        setFlowStatus('Approved');
        connectApi.post('api/Channels/ChangeSpecialConditionStatusFlow_by1', data, approverSPCallback);
    }
    const approverSPCallback = (status, data) => {
        let ids = []
        let newTable;
        setShowModal(true);
        if (data) {
            data[0].forEach(e => {
                ids.push(e.key);
            });
            setDataFormModal(ids);
            newTable = tableData.filter(function (sc) {
                return ids.indexOf(sc.idSpecialCondition) < 0;
            });
            setTableData(newTable)
            setSpecialConditionList([]);
        } else {
            setTableData(data)
        }

        newTable.forEach(obj => {
            obj.rowConfig = { 'selected': false };
        });
        fetchData();
    }

    const deactivateModal = () => { setShowModal(false); }
    const deactivateRejectModal = () => { setRejectModal(false); }

    const [showModal, setShowModal] = useState(false);
    const [showRejectModal, setRejectModal] = useState(false);
    const [dataForModal, setDataFormModal] = useState([]);
    const [flowStatus, setFlowStatus] = useState("");

    //Starts special condition reject FLOW
    const rejectSCFlow = () => {
        setIsLoading(true);
        setShowSCDetail(false);
        let payload = {
            specialConditionsList: specialConditionsList,
            email: authenticationService.currentUserValue.email,
            status: 'Rejected'
        }
        setFlowStatus('Rejected');
        setRejectModal(false);
        connectApi.post('api/Channels/ChangeSpecialConditionStatusFlow', payload, approverSPCallback);
    }
    const rejectSCFlowby1 = () => {
        setIsLoading(true);
        setShowSCDetail(false);
        let payload = {
            specialConditionsList: specialConditionsList,
            email: userEmail,
            status: 'Rejected'
        }
        let data={
            payload:payload,
            SpecialCondition:specialConditionDetail
        }
        setFlowStatus('Rejected');
        setRejectModal(false);
        connectApi.post('api/Channels/ChangeSpecialConditionStatusFlow_by1', data, approverSPCallback);
    }

    const [idSpecialContion, setIdSpecialCondtion] = useState([]);
    const [showSCDetail, setShowSCDetail] = useState(false);

    const hideSCDetailsModal = () => {

        if (specialConditionsListCopy && specialConditionsListCopy.length > 0) {
            setSpecialConditionList(specialConditionsListCopy);
            setSpecialConditionsIds(specialConditionsListCopy);
        } else {
            setSpecialConditionList([]);
        }
        setShowSCDetail(false);
        
    }

    const [specialConditionDetail, setSpecialConditionDetail] = useState([]);
    const [specialConditionsListCopy, setSpecialConditionsListCopy] = useState([]);

    $("#SpecialConditionsTable").off().on('click', (function (e) {
        if (e.target.nodeName != 'INPUT') {
            if( !($(e.target).closest('tr').children().eq(1).text()==t('Special Condition')
                || $(e.target).closest('tr').children().eq(1).text()=='')
            ){
                if (specialConditionsList.length > 0) {
                    setSpecialConditionsListCopy(specialConditionsList);
                }
                e.stopPropagation();
                var id = $(e.target).closest('tr').children().eq(1).text();
                if (tableData.length > 0 && id != "idSpecialCondition") {
                    setSpecialConditionList([]);
                    setIdSpecialCondtion(id);
                    let sc = tableData.find(sc => sc.idSpecialCondition == id);
                    setSpecialConditionDetail(sc);
                    setSpecialConditionList([]);
                    setSpecialConditionList([id.toString()]);
                    setShowSCDetail(true);
                }
            }
        }
    }));
    const [usersList, setUsersList] = useState([]);
    function callCheckFileExist ( dataSpecialCondition ){
        let data = new FormData();
        data.append("name", dataSpecialCondition.idSpecialCondition 
                + "-" + dataSpecialCondition.idCustomer 
                + "-" + dataSpecialCondition.idEndUser + ".pdf");
        data.append("flag", "false");
        data.append("idSC", dataSpecialCondition.idSpecialCondition)
        let returnUsers = (status, users) => {
            setUsersList(users);
        }
        let returnCall = (status, flag) => {
            setFileExist(flag);
            setShowSCDetail(true);
            if(flag) connectApi.post('api/Channels/checkUsersDowload', data, returnUsers);
        }
        connectApi.post('api/Channels/checkFileExistLetter', data, returnCall);
    }

    $("#SpecialConditionsTableLvl3").off().on('click', (function (e) {
        if (e.target.nodeName != 'INPUT') {
            if( !($(e.target).closest('tr').children().eq(0).text()==t('Special Condition')
                || $(e.target).closest('tr').children().eq(0).text()=='')
            ){
                e.stopPropagation();
                var id = $(e.target).closest('tr').children().eq(0).text();
                if (tableData.length > 0 && id != "idSpecialCondition") {
                    setSpecialConditionList([]);
                    setIdSpecialCondtion(id);
                    let sc = tableData.find(sc => sc.idSpecialCondition == id);
                    setSpecialConditionDetail(sc);
                    setSpecialConditionList([]);
                    setSpecialConditionList([id.toString()]);
                    callCheckFileExist(sc);
                }
            }
        }
    }));
    const aceptetLetter = () => {
        setFileUpdate(true);
        setShowSCDetail(false);
    }
   
    const [fileExist, setFileExist] = useState(false)
    const [fileUpdate, setFileUpdate] = useState(false);
    const [submitSend, setSubmitSend] = useState(true);
    const [showNotification, setShowNotification] = useState(false);
    const [notificationDetails, setNotificationDetails] = useState({ title: '', type: '', description: '' });
    const [fileSelectedToUpdate, setFileSelectedToUpdate] = useState(undefined);
    const [fileSize, setFileSize] = useState(0);
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
 
    const closeModal = () => {
        setFileUpdate(false);
        setSubmitSend(true);
        setFileSelectedToUpdate(undefined);
        setShowNotification(false);
    }
 
    function handleChangeFSU (event) {
        setFileSelectedToUpdate(event.target.files[0]);
        if(event.target.files[0]) setSubmitSend(false);
        else setSubmitSend(true);
    }

    function checkSizeToUpload (){
        let returnSize = (status, value) => {
            setFileSize(value);
        }
        connectApi.post('api/Channels/checkSizeToUpload', null, returnSize);
    }

    //Filtros de datos y ordenacion
    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if( orderBy == t('specialcondition.startdate') || orderBy == t('specialcondition.enddate') ){
            if (Date.parse(bSort) < Date.parse(aSort))
                return -1;
            if (Date.parse(bSort) > Date.parse(aSort))
                return 1;
        } else if( orderBy == t('Special Condition') ) {
            if (parseInt(bSort) < parseInt(aSort))
                return -1;
            if (parseInt(bSort) > parseInt(aSort))
                return 1;
        } else {
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1;
        }
        return 0;
    }
    function filterSort(array, orderBy, orderType) {
        return array.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }
    const [pageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const handlePageChange = (page) => setCurrentPage(page);
    const totalItems = tableData.length;
    const [orderBy, setOrderBy] = useState(t('Special Condition'));
    const [orderType, setOrderType] = useState("descending");
    const handleSort = (_, { id, type }) => {
        setOrderBy(id);
        setOrderType(type);
    };
    const filteredData = filterSort( tableData, orderBy, orderType );
    const pagedData = filteredData.slice((currentPage - 1) * pageSize, (currentPage - 1) * pageSize + pageSize);

    const submitSaveFile = () => {
        // 1 Mb = 1048576
        if ( fileSelectedToUpdate.size > fileSize ){
            setNotificationDetails({
                title: "Error",
                type: 'negative',
                description: t('errorSize') + " ("+ (fileSize/1048576) + " Mb)."
            });
            setShowNotification(true);
        } else if( fileSelectedToUpdate.name.substr(-4,4) != ".pdf" || fileSelectedToUpdate.type != "application/pdf") {
            setNotificationDetails({
                title: "Error",
                type: 'negative',
                description: t('errorTypePdf')
            });
            setShowNotification(true);
        } else {
            setSubmitSend(true);
            const handleUploadResponse = (status, response) => {
                if (response[0] === 'allGood') {
                    setNotificationDetails({
                        title: t('notifyAllCorrect'),
                        type: 'positive',
                        description: ''
                    });
                    setTimeout(() => {
                        closeModal();
                        fetchData();
                    }, 700);
                } else {
                    setNotificationDetails({
                        title: "Error",
                        type: 'negative',
                        description: t('notifySQLError')
                    });
                    setSubmitSend(false);
                }
                setShowNotification(true);
            }
            let name = specialConditionDetail.idSpecialCondition + "-" + specialConditionDetail.idCustomer + "-" + specialConditionDetail.idEndUser + ".pdf";
            let data = new FormData();
            data.append("file", fileSelectedToUpdate);
            data.append("fileName", name);
            data.append("specialCondition", JSON.stringify(specialConditionDetail));
            connectApi.post( "api/Channels/uploadFileLetterFromCustomer", data, handleUploadResponse );
        }
    }
    
    if(currentUser.idRole == 9){//9
        return (<>
            <ApprovalConfirmationModal onHideModel={deactivateModal} isModalShowing={showModal} data={dataForModal} status={flowStatus } />
            <Modal
                id = "pickerPDF-modal"
                closeButton
                onClose = { () => closeModal() }
                show = {fileUpdate}
                title = {t('pdfUpdate')}
                footer={(
                  <div className="vn-button-group--responsive">
                    <FilePicker label = {t('selectFile')} id = "file-picker" accept = ".pdf" onChange = { handleChangeFSU } value={fileSelectedToUpdate} />
                    {showNotification ? (
                    <div className="show-animated" >
                        <InlineNotification
                            title={notificationDetails.title}
                            type={notificationDetails.type}
                            description={notificationDetails.description}
                            onClose={() => { setShowNotification(false) }}
                        /> 
                    </div>):("")}
                    <br />
                    <Button disabled = {submitSend} onClick={() => submitSaveFile() } >{t('Submit')}</Button> 
                    <Button appearance="secondary" onClick={() => closeModal() }>{t('cancel')}</Button>
                  </div>
                )}
            >
            <p>{t('messageForCustomerUploadApproval')}</p>
            </Modal>
            <Table id='SpecialConditionsTableLvl3'
                columns={ [
                    {
                        id: 'idSpecialCondition',
                        label: t('Special Condition'),
                    }, {
                        id: 'specialConditionType',
                        label: t('Special Condition Type'),
                    }, {
                        id: 'customerName',
                        label: t('channels'),
                    }, {
                        id: 'endUserName',
                        label: t('endUserName'),
                    }, {
                        id: 'createdBy',
                        label: t('created_by'),
                    }, {
                        id: 'startDate',
                        label: t('specialcondition.startdate'),
                    }, {
                        id: 'endDate',
                        label: t('specialcondition.enddate'),
                    }, {
                        id: 'idPress',
                        label: t('pressid'),
                    }, {
                        id: 'idSpecialCondition',
                        label: t('Special Condition'),
                        index: 'visible',
                    }
                ]}
                data={pagedData}
                loading={isLoading}
                pagination={{
                    currentPage,
                    onPageChange: handlePageChange,
                    pageSize,
                    totalItems,
                }}
                showFilters
                onSort={handleSort}
                preferences={{
                    sortBy: {
                        id: orderBy,
                        type: orderType,
                    }
                }}
            >
            </Table>
            <SpecialConditionDetailLvlChannel
                onShowModal={showSCDetail} setShowSCDetail={setShowSCDetail} onCloseSCDetailsModal={hideSCDetailsModal} SpecialConditionDetail={specialConditionDetail} 
                aceptetLetter={aceptetLetter} rejectSCFlowby1={rejectSCFlowby1} fileExist={fileExist} setFileExist={setFileExist} usersList={usersList}
            />
        </>)
    } else {
        return (<>
            <ApprovalConfirmationModal onHideModel={deactivateModal} isModalShowing={showModal} data={dataForModal} status={flowStatus } />
            <RejectConfirmationModal onHideModel={deactivateRejectModal} onReject={rejectSCFlow} isModalShowing={showRejectModal} data={specialConditionsList} />
            <ConfirmationModal 
                id="confirmation-modal"
                onConfirm={() => { setModalState({ show: false }); approvingSCFlow(); }}
                onClose={() => setModalState({ show: false })}
                show={modalState.show}
                title={t('requestConfirmation')}
            >
                <p>
                    {t('confirmApprove')}
                    <b> {specialConditionsList.join(', ')}</b>
                    .
                </p>
            </ConfirmationModal>
            <Table id='SpecialConditionsTable'
                columns={ [
                    {
                        id: 'idSpecialCondition',
                        label: t('Special Condition'),
                    }, {
                        id: 'specialConditionType',
                        label: t('Special Condition Type'),
                    }, {
                        id: 'customerName',
                        label: t('channels'),
                    }, {
                        id: 'endUserName',
                        label: t('endUserName'),
                    }, {
                        id: 'createdBy',
                        label: t('created_by'),
                    }, {
                        id: 'startDate',
                        label: t('specialcondition.startdate'),
                    }, {
                        id: 'endDate',
                        label: t('specialcondition.enddate'),
                    }, {
                        id: 'idPress',
                        label: t('pressid'),
                    }, {
                        id: 'idSpecialCondition',
                        label: t('Special Condition'),
                        index: 'visible',
                    }
                ]}
                data={pagedData}
                loading={isLoading}
                rowSelector="multiSelection"
                onSelect={handleRowSelect}
                rowSelectAllState={selectionState(pagedData)}
                onSelectAllPageItems={handleSelectAllItems}
                pagination={{
                    currentPage,
                    onPageChange: handlePageChange,
                    pageSize,
                    totalItems,
                }}
                showFilters
                onSort={handleSort}
                preferences={{
                    sortBy: {
                        id: orderBy,
                        type: orderType,
                    }
                }}
            >
            </Table>
            <Button style={{marginRight: '5px'}} onClick={ApprovedSelectedEC}>{t('approve')}</Button>
            <Button onClick={RejectEC} appearance="secondary">{t('reject')}</Button>
            <SpecialConditionDetail idSpecialCondition={idSpecialContion} onShowModal={showSCDetail} onCloseSCDetailsModal={hideSCDetailsModal} 
                SpecialConditionDetail={specialConditionDetail} confirmationFunction={approvingSCFlow_by1} rejectSCFlow={rejectSCFlowby1 } />
        </>)
    }
}

export default SpecialConditionApproval;
